import { classNames } from "src/helpers/classNames";

export const Loader2 = ({ size = "lg", text = "Loading...", textClass }) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xlg: "h-9 w-9",
    xl: "h-10 w-10",
    xxl: "h-12 w-12",
  };

  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className={classNames("animate-spin rounded-full border-[4px] border-transparent border-r-[#4fa3e3] border-t-[#4fa3e3]", sizes[size])} />
      {text && <span className={classNames("mt-2 text-gray-500", textClass)}>{text}</span>}
    </div>
  );
};
